// image — static image. PBI report images often have null imageSrc because
// the binary lives inside the PBIX; backend may supply a real URL later.

import type { VisualProps } from "./types";
import "./_static.css";

export function ImageVisual({ spec }: VisualProps) {
  const src = spec.imageSrc ?? null;
  return (
    <div className="static-card static-image">
      {src ? (
        <img src={src} alt={spec.title ?? ""} className="static-image-img" />
      ) : (
        <div className="static-image-placeholder">{spec.title ?? "Image"}</div>
      )}
    </div>
  );
}
